'use client';
import styled from 'styled-components';

export const BackgroundColorContainer = styled.div`
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  width: 100%;
`;
